import React, { useContext } from 'react';
import {
  AuthContext,
  IAuthContext,
} from '../../../state/providers/AuthProvider';
import Avatar from '../../Avatar';
import split from 'lodash/split';

const UserAvatar = () => {
  const context: IAuthContext = useContext(AuthContext);
  const email = split(context.emailId, '@', 1).toString();
  return <Avatar name={email} type="icon"></Avatar>;
};

export default UserAvatar;
